import React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { BASE_URL, pythonBaseUrl } from "../../App_Settings/app_settings";
import InstaColors, { fontFamily } from "../Constants/constants";
import { screenHeaderStyle } from "../Constants/constants";
import { useSharedValue } from "../Constants/constants";
import LoaderIndicator from "../../Utility/loading";
import "../../App.css";
import {
  getUserFileAuditByUserId,
  getUserIdFromLocalStorage,
  getReport,
} from "../../API_Endpoints/APIEndpoints";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import EmailIcon from "@mui/icons-material/Email";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { TextField } from "@mui/material";
import { useHistory } from "react-router-dom";

export default function ReportsProcess() {
  const viewAuditColumnsData = [
    { field: "fileName", headerName: "FILE NAME", width: 150 },
    { field: "userName", headerName: "USER NAME", width: 150 },
    { field: "email", headerName: "EMAIL", width: 150 },
    { field: "action", headerName: "ACTION", width: 150 },
    { field: "actionDate", headerName: "ACTION DATE", width: 150 },
  ];

  // For the Extraction Report view columns:
  const viewExportedColumnsData = [
    { field: "File Name", headerName: "FILE NAME", width: 150 },
    { field: "Created By", headerName: "CREATED BY", width: 150 },
    { field: "Created Date", headerName: "CREATED DATE", width: 150 },
    { field: "Organization Name", headerName: "ORGANIZATION NAME", width: 150 },
    { field: "Type", headerName: "TYPE", width: 120 },
    { field: "Total Pages", headerName: "TOTAL PAGES", width: 120 },
    { field: "Total Forms", headerName: "TOTAL FORMS", width: 120 },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const { defaultBusinessunit, defaultOrganization, defaultUser } = useSharedValue();
  const { isMenuOpen } = useSharedValue();
  const history = useHistory();

  // User role state - kept for compatibility but role checking is now done in centralized function
  const [userRole, setUserRole] = useState("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  // Helper functions to get effective user ID and organization ID
  const getEffectiveUserId = () => {
    // Check if defaultUser exists and has a userId, otherwise use current user
    return defaultUser && defaultUser.id ? defaultUser.id : getUserIdFromLocalStorage().userId;
  };

  const getEffectiveOrganizationId = () => {
    // Check if defaultOrganization exists and has an organizationId, otherwise use current organization
    return defaultOrganization && defaultOrganization.id
      ? defaultOrganization.id
      : getUserIdFromLocalStorage().organizationId;
  };

  const [loading, setLoading] = useState(true);
  const [reportDataForView, setReportDataForView] = useState([]);
  const [filteredReportData, setFilteredReportData] = useState([]);
  const [viewingReport, setViewingReport] = useState(false);
  const [viewingReportName, setViewingReportName] = useState(null);

  const [viewColumns, setViewColumns] = useState([]);

  // Search functionality states
  const [searchTerm, setSearchTerm] = useState("");
  const [searchCategory, setSearchCategory] = useState("email");
  const [availableEmails, setAvailableEmails] = useState([]);
  const [availableOrganizations, setAvailableOrganizations] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [groupedData, setGroupedData] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [emailSubject, setEmailSubject] = useState("");

  // Initialize rows state
  const [rows, setRows] = useState([
    { id: 1, reportName: "User Audit Report" },
    { id: 2, reportName: "Extraction Report" },
  ]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filteredByDateData, setFilteredByDateData] = useState([]);

  // Add new state variables for schedule email settings
  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);
  const [selectedFrequency, setSelectedFrequency] = useState("");
  const [selectedReport, setSelectedReport] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");
  const [scheduleSettings, setScheduleSettings] = useState([]);

  // Frequency options
  const frequencyOptions = [
    { value: "daily", label: "Every Day" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "sixMonths", label: "Every Six Months" },
    { value: "yearly", label: "Yearly" },
  ];

  // Add useEffect to handle initial loading
  useEffect(() => {
    // Simulate data loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (viewingReportName) {
      handleViewReport(viewingReportName);
    }
  }, [viewingReportName, defaultUser, defaultOrganization]);
  // Using centralized getReport function from APIEndpoints.js

  // Extract unique emails and organizations when report data is loaded
  useEffect(() => {
    if (reportDataForView.length > 0) {
      // Extract unique emails
      const emails = new Set();
      reportDataForView.forEach((item) => {
        if (item.email) emails.add(item.email);
        if (item.EMAIL) emails.add(item.EMAIL);
      });
      setAvailableEmails(Array.from(emails).filter(Boolean));

      // // Extract unique organization names
      // const organizations = new Set();
      // reportDataForView.forEach(item => {
      //     if (item.organizationName) organizations.add(item.organizationName);
      //     if (item["Organization Name"]) organizations.add(item["Organization Name"]);
      //     // Also check for Created By field which might contain organization info
      //     if (item["Created By"]) organizations.add(item["Created By"]);

      // });
      // setAvailableOrganizations(Array.from(organizations).filter(Boolean));

      // Set filtered data initially to all data
      setFilteredReportData(reportDataForView);
    }
  }, [reportDataForView]);

  // Update dropdown options based on search category
  useEffect(() => {
    if (searchCategory === "email") {
      setDropdownOptions(availableEmails);
    } else {
      setDropdownOptions(availableOrganizations);
    }
  }, [searchCategory, availableEmails, availableOrganizations]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}/${date.getFullYear()}`;
  };
  const handlePdfReport = async (reportName) => {
    try {
      if (reportName === "User Audit Report") {
        const actualReportName = reportName;
        // Prefer already loaded data (icon should behave like button/view)
        let data =
          Array.isArray(filteredReportData) && filteredReportData.length > 0
            ? filteredReportData
            : Array.isArray(reportDataForView) && reportDataForView.length > 0
              ? reportDataForView
              : null;

        // Fallback: fetch fresh data if nothing loaded yet
        if (!data) {
          const effectiveUserId = getEffectiveUserId();
          const effectiveOrganizationId = getEffectiveOrganizationId();
          const userAuditData = await getUserFileAuditByUserId(
            effectiveUserId,
            effectiveOrganizationId
          );
          data = userAuditData;
        }

        // Make sure we have data
        if (data.length === 0) {
          alert("No data available to generate PDF");
          return;
        }

        // Generate PDF with proper data
        const doc = generatePDF(data, actualReportName);
        doc.save(`${actualReportName}_${new Date().toISOString().split("T")[0]}.pdf`);
      } else if (reportName === "Extraction Report") {
        console.log("Calling getReport with:", {
          defaultUser,
          defaultOrganization,
        });
        const result = await getReport(defaultUser, defaultOrganization);
        console.log("getReport result:", result);
        if (result.success) {
          // Build a robust data list for PDF generation (mirrors view logic with fallbacks)
          const dataList = result.data.map((item, index) => {
            let jsonData;
            try {
              jsonData = JSON.parse(item.json);
            } catch (error) {
              console.error(`❌ PDF - Failed to parse JSON for item ${index}:`, error);
              jsonData = item;
            }

            const totalPages =
              jsonData["Total Pages"] ||
              jsonData["totalPages"] ||
              jsonData.totalPage ||
              item.totalPage ||
              item.totalPages ||
              "N/A";

            const totalForms =
              jsonData["Total Forms"] ||
              jsonData["totalForms"] ||
              jsonData.totalForms ||
              item.totalForms ||
              item.totalForm ||
              "N/A";

            // Keep remaining keys except totals
            const remaining =
              typeof jsonData === "object" && jsonData !== null
                ? Object.fromEntries(
                    Object.entries(jsonData).filter(
                      ([key]) => key !== "Total Pages" && key !== "Total Forms"
                    )
                  )
                : {};

            return {
              "File Name": item.fileName,
              "Created By": item.createdBy,
              "Created Date": item.createdDate,
              "Organization Name": item.organizationName || "Unknown",
              "Total Pages": totalPages,
              "Total Forms": totalForms,
              ...remaining,
            };
          });

          const actualReportName = reportName;

          if (dataList.length === 0) {
            alert("No data available to generate PDF");
            return;
          }

          const doc = generatePDF(dataList, actualReportName);
          doc.save(`${actualReportName}_${new Date().toISOString().split("T")[0]}.pdf`);
        } else {
          throw new Error("Failed to retrieve Extraction Report");
        }
      }
    } catch (error) {
      console.error("Error viewing report:", error);
    }
  };

  // Excel icon: behave like PDF icon (load data then download locally as CSV)
  const handleExcelReport = async (reportName) => {
    try {
      if (reportName === "User Audit Report") {
        const actualReportName = reportName;

        // Start with full dataset
        let data = reportDataForView;

        // Prioritize filtered data if available and different from full dataset
        if (
          Array.isArray(filteredReportData) &&
          filteredReportData.length > 0 &&
          filteredReportData.length !== reportDataForView.length
        ) {
          console.log(
            "🔍 Excel User Audit - Using filtered data:",
            filteredReportData.length,
            "records"
          );
          data = filteredReportData;
        } else if (
          Array.isArray(filteredByDateData) &&
          filteredByDateData.length > 0 &&
          filteredByDateData.length !== reportDataForView.length
        ) {
          console.log(
            "🔍 Excel User Audit - Using date filtered data:",
            filteredByDateData.length,
            "records"
          );
          data = filteredByDateData;
        } else {
          console.log(
            "🔍 Excel User Audit - Using full dataset:",
            reportDataForView.length,
            "records"
          );
        }

        // Fallback fetch if nothing loaded
        if (!data || data.length === 0) {
          const effectiveUserId = getEffectiveUserId();
          const effectiveOrganizationId = getEffectiveOrganizationId();
          data = await getUserFileAuditByUserId(effectiveUserId, effectiveOrganizationId);
        }

        if (!data || data.length === 0) {
          alert("No data available to generate Excel");
          return;
        }

        const csv = generateCSV(data);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${actualReportName}_${new Date().toISOString().split("T")[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else if (reportName === "Extraction Report") {
        // Reuse the exact same data processing logic as handleViewReport
        const result = await getReport(defaultUser, defaultOrganization);
        if (!result || !result.success || !Array.isArray(result.data)) {
          alert("Failed to load Extraction Report data");
          return;
        }

        // Build data list using the same production logic as the view
        const dataList = result.data.map((item, index) => {
          let jsonData = {};
          try {
            // Check if item.json exists and is not empty
            if (item.json && typeof item.json === "string" && item.json.trim() !== "") {
              jsonData = JSON.parse(item.json);
            } else {
              console.warn(`⚠️ Excel - Empty or missing JSON for item ${index}, using item data`);
              jsonData = item;
            }
          } catch (error) {
            console.error(`❌ Excel - Failed to parse JSON for item ${index}:`, error);
            console.error(`❌ Excel - Raw item.json:`, item.json);
            jsonData = item;
          }

          // Extract total pages and forms with multiple fallback options
          const totalPages =
            jsonData["Total Pages"] ||
            jsonData["totalPages"] ||
            jsonData.totalPage ||
            item.totalPage ||
            item.totalPages ||
            "N/A";

          const totalForms =
            jsonData["Total Forms"] ||
            jsonData["totalForms"] ||
            jsonData.totalForms ||
            item.totalForms ||
            item.totalForm ||
            "N/A";

          // Extract type information and capitalize first letter
          const rawType =
            jsonData["Type"] ||
            jsonData.type ||
            item.type ||
            item.processType ||
            item.extractionType ||
            "extraction";

          const extractionType = rawType.charAt(0).toUpperCase() + rawType.slice(1).toLowerCase();

          return {
            "File Name": item.fileName || "Unknown",
            "Created By": item.createdBy || "Unknown",
            "Created Date": item.createdDate || "Unknown",
            "Organization Name": item.organizationName || "Unknown",
            Type: extractionType,
            "Total Pages": totalPages,
            "Total Forms": totalForms,
            ...Object.fromEntries(
              Object.entries(jsonData || {}).filter(
                ([key]) => key !== "Total Pages" && key !== "Total Forms"
              )
            ),
          };
        });

        // Apply filters if user has filtered the view
        let exportData = dataList;

        // Check if we have filtered data and it's different from the full dataset
        if (
          Array.isArray(filteredReportData) &&
          filteredReportData.length > 0 &&
          filteredReportData.length !== dataList.length
        ) {
          console.log("🔍 Excel - Using filtered data:", filteredReportData.length, "records");
          exportData = filteredReportData;
        } else if (
          Array.isArray(filteredByDateData) &&
          filteredByDateData.length > 0 &&
          filteredByDateData.length !== dataList.length
        ) {
          console.log("🔍 Excel - Using date filtered data:", filteredByDateData.length, "records");
          exportData = filteredByDateData;
        } else {
          console.log("🔍 Excel - Using full dataset:", dataList.length, "records");
        }

        if (!exportData || exportData.length === 0) {
          alert("No data available to generate Excel");
          return;
        }

        // Append totals row like the view does
        const totals = calculateTotals(exportData);
        const finalData = totals ? [...exportData, totals] : exportData;

        const csv = generateCSV(finalData);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Extraction Report_${new Date().toISOString().split("T")[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      console.error("Error generating Excel:", e);
      alert("Failed to generate Excel. Please try again.");
    }
  };

  const handleViewReport = async (reportName) => {
    setViewingReport(true);
    setIsLoading(true);

    try {
      if (reportName === "User Audit Report") {
        setViewingReportName("User Audit Report");
        const effectiveUserId = getEffectiveUserId();
        const effectiveOrganizationId = getEffectiveOrganizationId();
        const userAuditData = await getUserFileAuditByUserId(
          effectiveUserId,
          effectiveOrganizationId
        );
        console.log("User Audit Data:", userAuditData); // Debug log
        setReportDataForView(userAuditData);
        setFilteredReportData(userAuditData);
        setViewColumns(viewAuditColumnsData);
      } else if (reportName === "Extraction Report") {
        setViewingReportName("Extraction Report");
        const result = await getReport(defaultUser, defaultOrganization);
        console.log("🔍 Report Screen - getReport result:", result);
        if (result.success) {
          console.log("🔍 Report Screen - result.data:", result.data);
          console.log(
            "🔍 Report Screen - result.data length:",
            result.data ? result.data.length : 0
          );

          // Create a data list for viewing
          const dataList = result.data.map((item, index) => {
            console.log(`🔍 Report Screen - Processing item ${index}:`, item);
            console.log(`🔍 Report Screen - item.json:`, item.json);
            console.log(`🔍 Report Screen - typeof item.json:`, typeof item.json);

            let jsonData;
            try {
              jsonData = JSON.parse(item.json);
              console.log(`🔍 Report Screen - Parsed jsonData:`, jsonData);
            } catch (error) {
              console.error(`❌ Report Screen - Failed to parse JSON for item ${index}:`, error);
              console.error(`❌ Report Screen - Raw item.json:`, item.json);
              // Fallback: use the item directly if JSON parsing fails
              jsonData = item;
            }

            // Extract total pages and forms with multiple fallback options
            const totalPages =
              jsonData["Total Pages"] ||
              jsonData["totalPages"] ||
              jsonData.totalPage ||
              item.totalPage ||
              item.totalPages ||
              "N/A";

            const totalForms =
              jsonData["Total Forms"] ||
              jsonData["totalForms"] ||
              jsonData.totalForms ||
              item.totalForms ||
              item.totalForm ||
              "N/A";

            // Extract type information and capitalize first letter
            const rawType =
              jsonData["Type"] ||
              jsonData.type ||
              item.type ||
              item.processType ||
              item.extractionType ||
              "extraction";

            const extractionType = rawType.charAt(0).toUpperCase() + rawType.slice(1).toLowerCase();

            console.log(`🔍 Report Screen - Extracted values for item ${index}:`, {
              totalPages,
              totalForms,
              extractionType,
              originalItem: item,
              parsedJson: jsonData,
            });

            return {
              "File Name": item.fileName,
              "Created By": item.createdBy,
              "Created Date": item.createdDate,
              "Organization Name": item.organizationName || "Unknown",
              Type: extractionType,
              "Total Pages": totalPages,
              "Total Forms": totalForms,
              ...Object.fromEntries(
                Object.entries(jsonData).filter(
                  ([key]) => key !== "Total Pages" && key !== "Total Forms"
                )
              ),
            };
          });

          // Get all possible keys for columns
          const allKeys = new Set();
          dataList.forEach((item) => {
            Object.keys(item).forEach((key) => allKeys.add(key));
          });

          // Create columns, prioritizing certain fields
          const priorityFields = [
            "File Name",
            "Created By",
            "Organization Name",
            "Created Date",
            "Type",
            "Total Pages",
            "Total Forms",
          ];
          const otherFields = [...allKeys].filter((field) => !priorityFields.includes(field));

          const viewColumnsData = [
            ...priorityFields.map((field) => ({
              field,
              headerName: field.toUpperCase(),
              width: 150,
            })),
            ...otherFields.map((field) => ({
              field,
              headerName: field.toUpperCase(),
              width: 150,
            })),
          ];

          setViewColumns(viewColumnsData);
          setReportDataForView(dataList);
          setFilteredReportData(dataList);
        } else {
          console.error("❌ Report Screen - getReport failed:", result);
          console.error("❌ Report Screen - getReport error:", result.error);
          setReportDataForView([]);
          setFilteredReportData([]);
          setViewColumns(viewExportedColumnsData);
          throw new Error("Failed to retrieve Extraction Report");
        }
      }
    } catch (error) {
      console.error("❌ Report Screen - Error viewing report:", error);
      // Set empty data when there's an exception
      setReportDataForView([]);
      setFilteredReportData([]);
      if (reportName === "Extraction Report") {
        setViewColumns(viewExportedColumnsData);
      } else {
        setViewColumns(viewAuditColumnsData);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Date formatter function to convert dates to DD/MM/YYYY format

  // Enhanced function to calculate totals for Extraction Report
  const calculateTotals = (data) => {
    if (data.length === 0) return null;

    // Initialize totals object with standard fields
    const totals = {
      "File Name": "TOTALS",
      "Created By": "",
      "Created Date": "",
      "Organization Name": "",
      Type: "", // Empty string for Type column in totals
      "Total Pages": 0,
      "Total Forms": 0,
    };

    // First, collect all possible form type keys from ALL rows
    const formTypeKeys = new Set();
    data.forEach((row) => {
      Object.keys(row).forEach((key) => {
        // If it's not one of the standard fields and seems to be a form type
        if (
          ![
            "File Name",
            "Created By",
            "Created Date",
            "Organization Name",
            "Type",
            "Total Pages",
            "Total Forms",
          ].includes(key)
        ) {
          formTypeKeys.add(key);
        }
      });
    });

    // Initialize all form type counters to 0
    formTypeKeys.forEach((key) => {
      totals[key] = 0;
    });

    // Calculate sums for all numeric fields across all rows
    data.forEach((row) => {
      // Sum standard numeric fields
      if (row["Total Pages"]) {
        const pages = parseInt(row["Total Pages"]);
        if (!isNaN(pages)) totals["Total Pages"] += pages;
      }

      if (row["Total Forms"]) {
        const forms = parseInt(row["Total Forms"]);
        if (!isNaN(forms)) totals["Total Forms"] += forms;
      }

      // Sum all form types
      formTypeKeys.forEach((key) => {
        if (row[key]) {
          // Only attempt to parse if it seems to be a numeric value
          const value =
            typeof row[key] === "string" && row[key].includes("page")
              ? parseInt(row[key])
              : parseInt(row[key]);

          if (!isNaN(value)) {
            totals[key] += value;
          }
        }
      });
    });

    return totals;
  };

  const handleDownloadExcelReport = (reportName, useFiltered = false) => {
    setIsLoading(true);
    console.log("Report to download:", reportName, "Using filtered data:", useFiltered);

    const dateFields = new Set(["actionDate"]);

    // Helper function to generate and download CSV file
    const downloadCSVFile = (data, filename) => {
      try {
        // Generate CSV content
        const csv = generateCSV(data);

        // Create blob from CSV content
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

        // Create download link and trigger download
        const downloadUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = downloadUrl;
        downloadLink.download = `${filename}.csv`;

        // Append to body, click, and remove
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        // Clean up the object URL
        window.URL.revokeObjectURL(downloadUrl);

        const downloadTime = new Date();
        localStorage.setItem("downloadTime", downloadTime);
        console.log(`${reportName} downloaded successfully: ${filename}.csv`);
        setIsLoading(false);
      } catch (error) {
        console.error("Error generating CSV file:", error);
        setIsLoading(false);
      }
    };

    if (reportName === "User Audit Report") {
      // User Audit Report code
      const effectiveUserId = getEffectiveUserId();
      const effectiveOrganizationId = getEffectiveOrganizationId();

      getUserFileAuditByUserId(effectiveUserId, effectiveOrganizationId)
        .then((data) => {
          // If filtered data should be used and is available, use filteredReportData directly
          let userAuditList = data;

          if (useFiltered) {
            // Check if we have filtered data and it's different from the full dataset
            if (
              Array.isArray(filteredReportData) &&
              filteredReportData.length > 0 &&
              filteredReportData.length !== data.length
            ) {
              console.log(
                "🔍 Excel Download - Using filtered data:",
                filteredReportData.length,
                "records"
              );
              userAuditList = filteredReportData;
            } else if (
              Array.isArray(filteredByDateData) &&
              filteredByDateData.length > 0 &&
              filteredByDateData.length !== data.length
            ) {
              console.log(
                "🔍 Excel Download - Using date filtered data:",
                filteredByDateData.length,
                "records"
              );
              userAuditList = filteredByDateData;
            } else {
              console.log(
                "🔍 Excel Download - No filters applied, using full dataset:",
                data.length,
                "records"
              );
            }
          }

          // Format and transform the data
          userAuditList = userAuditList.map((item) => {
            const formattedItem = {};

            // Process each field in the item
            Object.keys(item).forEach((key) => {
              // Get the display name for the column or use the original key
              const displayKey = viewAuditColumnsData[key] || key;

              // Format date fields
              if (dateFields.has(key) && item[key]) {
                formattedItem[displayKey] = formatDate(item[key]);
              } else {
                formattedItem[displayKey] = item[key];
              }
            });

            return formattedItem;
          });

          // Create filename with current date and time
          const now = new Date();
          const dateTimeString = now.toISOString().replace(/[:.]/g, "-").slice(0, 19);
          const fileName = `user_audit_report_${dateTimeString}`;

          // Generate and download CSV file directly
          downloadCSVFile(userAuditList, fileName);
        })
        .catch((error) => {
          console.error("Error fetching User Audit Report data:", error);
          setIsLoading(false);
        });
    } else if (reportName === "Extraction Report") {
      // Extraction Report handling
      if (useFiltered) {
        // Determine which filtered data to use
        let dataToUse = filteredReportData;

        // Check if we have filtered data and it's different from the full dataset
        if (
          Array.isArray(filteredReportData) &&
          filteredReportData.length > 0 &&
          filteredReportData.length !== reportDataForView.length
        ) {
          console.log(
            "🔍 Excel Download Extraction - Using search filtered data:",
            filteredReportData.length,
            "records"
          );
          dataToUse = filteredReportData;
        } else if (
          Array.isArray(filteredByDateData) &&
          filteredByDateData.length > 0 &&
          filteredByDateData.length !== reportDataForView.length
        ) {
          console.log(
            "🔍 Excel Download Extraction - Using date filtered data:",
            filteredByDateData.length,
            "records"
          );
          dataToUse = filteredByDateData;
        } else {
          console.log("🔍 Excel Download Extraction - No filters applied, using full dataset");
          dataToUse = reportDataForView;
        }

        // Process filtered data
        // First extract all possible keys to ensure complete headers
        const allKeys = new Set();
        dataToUse.forEach((item) => {
          Object.keys(item).forEach((key) => {
            allKeys.add(key);
          });
        });

        // Format date fields in the filtered data
        const formattedData = dataToUse.map((item) => {
          const formattedItem = {};

          // Ensure all keys are present in each item (for consistent columns)
          Array.from(allKeys).forEach((key) => {
            // Format date fields
            if (dateFields.has(key) && item[key]) {
              formattedItem[key] = formatDate(item[key]);
            } else {
              formattedItem[key] = item[key] || ""; // Use empty string for missing values
            }
          });

          return formattedItem;
        });

        // Calculate totals for filtered data
        const totals = calculateTotals(formattedData);

        // Append totals row to the filtered data
        const dataWithTotals = [...formattedData];
        if (totals) dataWithTotals.push(totals);

        // Create filename with current date and time
        const now = new Date();
        const dateTimeString = now.toISOString().replace(/[:.]/g, "-").slice(0, 19);
        const fileName = `extraction_report_filtered_${dateTimeString}`;

        // Generate and download CSV file directly
        downloadCSVFile(dataWithTotals, fileName);
      } else {
        // Original flow for non-filtered data
        getReport(defaultUser, defaultOrganization)
          .then((result) => {
            if (result.success) {
              // Collect all possible keys from all items
              const allKeys = new Set();
              const dataList = result.data.map((item) => {
                let jsonData = {};
                try {
                  // Check if item.json exists and is not empty
                  if (item.json && typeof item.json === "string" && item.json.trim() !== "") {
                    jsonData = JSON.parse(item.json);
                  } else {
                    console.warn(`⚠️ View - Empty or missing JSON for item, using item data`);
                    jsonData = item;
                  }
                } catch (error) {
                  console.error(`❌ View - Failed to parse JSON:`, error);
                  console.error(`❌ View - Raw item.json:`, item.json);
                  jsonData = item;
                }

                // Extract total pages and forms with multiple fallback options
                const totalPages =
                  jsonData["Total Pages"] ||
                  jsonData["totalPages"] ||
                  jsonData.totalPage ||
                  item.totalPage ||
                  item.totalPages ||
                  "N/A";

                const totalForms =
                  jsonData["Total Forms"] ||
                  jsonData["totalForms"] ||
                  jsonData.totalForms ||
                  item.totalForms ||
                  item.totalForm ||
                  "N/A";

                // Extract type information and capitalize first letter
                const rawType =
                  jsonData["Type"] ||
                  jsonData.type ||
                  item.type ||
                  item.processType ||
                  item.extractionType ||
                  "extraction";

                const extractionType =
                  rawType.charAt(0).toUpperCase() + rawType.slice(1).toLowerCase();

                return {
                  "File Name": item.fileName || "Unknown",
                  "Created By": item.createdBy || "Unknown",
                  "Created Date": item.createdDate || "Unknown",
                  "Organization Name": item.organizationName || "Unknown",
                  Type: extractionType,
                  "Total Pages": totalPages,
                  "Total Forms": totalForms,
                  ...Object.fromEntries(
                    Object.entries(jsonData || {}).filter(
                      ([key]) => key !== "Total Pages" && key !== "Total Forms"
                    )
                  ),
                };
              });

              // First pass to collect all possible keys
              dataList.forEach((item) => {
                Object.keys(item).forEach((key) => {
                  allKeys.add(key);
                });
              });

              // Format date fields in the data
              const formattedData = dataList.map((item) => {
                const formattedItem = {};

                // Ensure all keys are present in each item (for consistent columns)
                Array.from(allKeys).forEach((key) => {
                  // Format date fields
                  if (dateFields.has(key) && item[key]) {
                    formattedItem[key] = formatDate(item[key]);
                  } else {
                    formattedItem[key] = item[key] || ""; // Use empty string for missing values
                  }
                });

                return formattedItem;
              });

              // Calculate totals for data
              const totals = calculateTotals(formattedData);

              // Append totals row to the data
              const dataWithTotals = [...formattedData];
              if (totals) dataWithTotals.push(totals);

              // Create filename with current date and time
              const now = new Date();
              const dateTimeString = now.toISOString().replace(/[:.]/g, "-").slice(0, 19);
              const fileName = `extraction_report_${dateTimeString}`;

              // Generate and download CSV file directly
              downloadCSVFile(dataWithTotals, fileName);
            } else {
              setIsLoading(false);
              console.error("Failed to retrieve Extraction Report data");
            }
          })
          .catch((error) => {
            console.error("Error fetching Extraction Report:", error);
            setIsLoading(false);
          });
      }
    }
  };

  const handleBackToReports = () => {
    setViewingReport(false);
    setReportDataForView([]);
    setFilteredReportData([]);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);

    // Apply search immediately or wait for user to finish typing
    if (e.target.value === "") {
      // Clear search results immediately when search box is emptied
      setFilteredReportData(reportDataForView);
    }
  };
  useEffect(() => {
    setFilteredReportData(filteredReportData);
  }, [filteredReportData]);

  // Modified filter function to search in both email and organization fields
  // Updated search filter function
  const filterReportData = () => {
    if (!searchTerm) {
      setFilteredReportData(reportDataForView);
      return;
    }
    console.log("Report Data For View:", reportDataForView);
    const lowercaseSearchTerm = searchTerm.toLowerCase();

    const filtered = reportDataForView.filter((item) => {
      // More comprehensive field checking for both report types
      return (
        // User Audit Report fields
        (item.email && item.email.toLowerCase().includes(lowercaseSearchTerm)) ||
        (item.userName && item.userName.toLowerCase().includes(lowercaseSearchTerm)) ||
        (item.fileName && item.fileName.toLowerCase().includes(lowercaseSearchTerm)) ||
        (item.organizationName &&
          item.organizationName.toLowerCase().includes(lowercaseSearchTerm)) ||
        // Extraction Report fields
        (item.EMAIL && item.EMAIL.toLowerCase().includes(lowercaseSearchTerm)) ||
        (item["Created By"] && item["Created By"].toLowerCase().includes(lowercaseSearchTerm)) ||
        (item["File Name"] && item["File Name"].toLowerCase().includes(lowercaseSearchTerm)) ||
        (item["Organization Name"] &&
          item["Organization Name"].toLowerCase().includes(lowercaseSearchTerm))
      );
    });

    setFilteredReportData(filtered);

    // Also update date-filtered data
    if (startDate && endDate) {
      setFilteredByDateData(filterDataByDateRange(filtered));
    } else {
      setFilteredByDateData(filtered);
    }
  };

  const groupDataByDate = (data) => {
    const grouped = {};
    data.forEach((item) => {
      // Check for both camelCase and spaced format date fields
      const date =
        item.createdDate ||
        item.uploadDate ||
        item.extractedDate ||
        item["Created Date"] ||
        item["Action Date"] ||
        item.actionDate;
      if (date) {
        const dateObj = new Date(date);
        const formattedDate = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(dateObj.getDate()).padStart(2, "0")}`;

        if (!grouped[formattedDate]) {
          grouped[formattedDate] = [];
        }
        grouped[formattedDate].push(item);
      }
    });
    return grouped;
  };

  // Updated generatePDF function with logo and additional user info
  const generatePDF = (data, reportName) => {
    const doc = new jsPDF();

    // Add logo
    const logoPath = "/logo.png";

    // Add logo (positioned at top left)
    doc.addImage(logoPath, "PNG", 14, 10, 50, 9);

    // Add title with correct report name (position adjusted to make room for logo)
    doc.setFontSize(16);
    doc.text(reportName, 14, 25);

    // Get user info from localStorage
    const userInfo = getUserIdFromLocalStorage();
    const name = `${userInfo.firstName} ${userInfo.lastName}`;
    const userName = name || "N/A";
    const userEmail = userInfo?.userName || "N/A";
    const organizationName = userInfo?.organizationName || "N/A";

    // Add user info
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);
    doc.text(`User: ${userName}`, 14, 35);
    doc.text(`Email: ${userEmail}`, 14, 40);
    doc.text(`Organization: ${organizationName}`, 14, 45);

    // Different columns based on report type
    const importantColumns =
      reportName === "User Audit Report"
        ? ["fileName", "userName", "email", "action", "actionDate"]
        : [
            "File Name",
            "Created By",
            "Created Date",
            "Organization Name",
            "Type",
            "Total Pages",
            "Total Forms",
          ];

    const headerNames =
      reportName === "User Audit Report"
        ? ["FILE NAME", "USER NAME", "EMAIL", "ACTION", "ACTION DATE"]
        : [
            "FILE NAME",
            "CREATED BY",
            "CREATED DATE",
            "ORGANIZATION NAME",
            "TYPE",
            "TOTAL PAGES",
            "TOTAL FORMS",
          ];

    // Prepare data for table - ensure data is properly formatted
    const tableData = data.map((item) => {
      return importantColumns.map((col) => {
        // Check if the item has the column and it's not null or undefined
        if (item[col] !== undefined && item[col] !== null) {
          if (col.includes("Date") || col.includes("date")) {
            return formatDate(item[col]);
          }
          return String(item[col]); // Convert to string to ensure it displays properly
        }
        return ""; // Empty string for missing data
      });
    });

    // Add totals row for Extraction Report
    if (reportName === "Extraction Report") {
      const totals = calculateTotals(data);
      if (totals) {
        const totalsRow = importantColumns.map((col) => {
          return totals[col] !== undefined ? String(totals[col]) : "";
        });
        tableData.push(totalsRow);
      }
    }

    // Add table with the properly formatted data - start at Y position 50 to make room for header information
    doc.autoTable({
      head: [headerNames],
      body: tableData,
      startY: 50,
      theme: "grid",
      headStyles: { fillColor: [41, 128, 185] },
      styles: { fontSize: 8 },
      footStyles: { fillColor: [238, 238, 238], fontStyle: "bold" },
    });

    return doc;
  };

  // Function to handle PDF download
  const handleDownloadPDF = (reportName) => {
    // Ensure we have the correct report name
    const actualReportName = viewingReportName || reportName;

    // Prioritize filtered data over full dataset
    let data = reportDataForView;

    if (
      Array.isArray(filteredReportData) &&
      filteredReportData.length > 0 &&
      filteredReportData.length !== reportDataForView.length
    ) {
      console.log("🔍 PDF - Using filtered data:", filteredReportData.length, "records");
      data = filteredReportData;
    } else if (
      Array.isArray(filteredByDateData) &&
      filteredByDateData.length > 0 &&
      filteredByDateData.length !== reportDataForView.length
    ) {
      console.log("🔍 PDF - Using date filtered data:", filteredByDateData.length, "records");
      data = filteredByDateData;
    } else {
      console.log("🔍 PDF - Using full dataset:", reportDataForView.length, "records");
    }

    // Make sure we have data
    if (!data || data.length === 0) {
      alert("No data available to generate PDF");
      return;
    }

    // Generate PDF with proper data
    const doc = generatePDF(data, actualReportName);
    doc.save(`${actualReportName}_${new Date().toISOString().split("T")[0]}.pdf`);
  };

  // Generate CSV content from array of objects (Excel-friendly)
  const generateCSV = (data) => {
    if (!data || data.length === 0) return "";

    // Build a stable ordered header from the union of keys across all rows
    const headerSet = new Set();
    data.forEach((row) => Object.keys(row || {}).forEach((k) => headerSet.add(k)));
    const headers = Array.from(headerSet);

    // CSV escape
    const esc = (val) => {
      if (val === null || val === undefined) return "";
      const str = String(val);
      if (/[",\n]/.test(str)) return '"' + str.replace(/"/g, '""') + '"';
      return str;
    };

    const lines = [];
    lines.push(headers.map(esc).join(","));
    data.forEach((row) => {
      const line = headers.map((h) => esc(row && row[h] !== undefined ? row[h] : ""));
      lines.push(line.join(","));
    });
    return lines.join("\n");
  };

  // Function to handle email PDF
  const handleEmailPDF = async (reportName) => {
    setIsLoading(true);
    try {
      const data = filteredReportData.length > 0 ? filteredReportData : reportDataForView;
      const doc = generatePDF(data, reportName);
      const pdfBlob = doc.output("blob");

      const formData = new FormData();
      formData.append("pdf", pdfBlob);
      formData.append("email", emailAddress);
      formData.append("subject", emailSubject || `${reportName} Report`);
      formData.append("organizationId", getUserIdFromLocalStorage().organizationId);
      formData.append("userId", getUserIdFromLocalStorage().userId);
      formData.append("businessUnit", "Demo"); // Default for reports

      const response = await fetch(`${pythonBaseUrl}/Email/SendEmail`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        alert("Email sent successfully!");
        setEmailDialogOpen(false);
      } else {
        throw new Error("Failed to send email");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send email. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // Update useEffect to group data when report data changes
  useEffect(() => {
    if (reportDataForView.length > 0) {
      const grouped = groupDataByDate(reportDataForView);
      setGroupedData(grouped);
      setSelectedDate(Object.keys(grouped)[0]);
    }
  }, [reportDataForView]);

  const filterDataByDateRange = (data) => {
    if (!startDate || !endDate) return data;

    return data.filter((item) => {
      // Check for both camelCase and spaced format date fields
      const itemDate = new Date(
        item.createdDate ||
          item.uploadDate ||
          item.actionDate ||
          item.extractedDate ||
          item["Created Date"] ||
          item["Action Date"]
      );
      return itemDate >= startDate && itemDate <= endDate;
    });
  };

  // Update filtered data when date range changes
  useEffect(() => {
    if (reportDataForView.length > 0) {
      const filtered = filterDataByDateRange(reportDataForView);
      setFilteredByDateData(filtered);
    }
  }, [startDate, endDate, reportDataForView]);

  // Function to handle schedule email settings
  const handleScheduleEmail = async () => {
    try {
      const scheduleData = {
        reportName: selectedReport,
        frequency: selectedFrequency,
        email: selectedEmail,
        userId: getUserIdFromLocalStorage().userId,
      };

      const response = await fetch(`${BASE_URL}/ReportSchedule/Create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: JSON.stringify(scheduleData),
      });

      if (response.ok) {
        alert("Schedule settings saved successfully!");
        setScheduleDialogOpen(false);
        // Refresh schedule settings
        // fetchScheduleSettings();
      } else {
        throw new Error("Failed to save schedule settings");
      }
    } catch (error) {
      console.error("Error saving schedule settings:", error);
      alert("Failed to save schedule settings. Please try again.");
    }
  };

  // Function to fetch existing schedule settings
  const fetchScheduleSettings = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/ReportSchedule/GetByUserId/${getUserIdFromLocalStorage().userId}`,
        {
          headers: {
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setScheduleSettings(data);
      }
    } catch (error) {
      console.error("Error fetching schedule settings:", error);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div id="extraction_Review" style={screenHeaderStyle(isMenuOpen)}>
        {/* Back button when viewing report data */}
        {viewingReport && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "20px 20px 10px 20px",
              cursor: "pointer",
            }}
            onClick={handleBackToReports}
          >
            <ArrowBackIcon
              style={{
                color: InstaColors.primary,
                fontSize: 24,
              }}
            />
          </div>
        )}

        {!viewingReport ? (
          <>
            <div
              style={{
                backgroundColor: InstaColors.primary,
                minBlockSize: "38px",
                marginLeft: "40px",
                paddingLeft: "20px",
                marginTop: 20,
                fontFamily: fontFamily,
                fontWeight: 400,
                fontSize: 13,
                paddingRight: "20px",
                marginRight: "40px",
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  textAlign: "left",
                  color: "white",
                  marginLeft: "5px",
                  marginRight: "5px",
                }}
              >
                Report Name
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    textAlign: "left",
                    width: 50,
                    color: "white",
                    marginLeft: "5px",
                    marginRight: "5px",
                  }}
                >
                  View
                </div>
                <div
                  style={{
                    textAlign: "left",
                    width: 50,
                    color: "white",
                    marginLeft: "5px",
                    marginRight: "5px",
                  }}
                >
                  Excel
                </div>
                <div
                  style={{
                    textAlign: "left",
                    width: 50,
                    color: "white",
                    marginLeft: "5px",
                    marginRight: "5px",
                  }}
                >
                  PDF
                </div>
                <div
                  style={{
                    textAlign: "left",
                    width: 80,
                    color: "white",
                    marginLeft: "5px",
                    marginRight: "5px",
                  }}
                >
                  Schedule
                </div>
              </div>
            </div>

            {loading ? (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#555",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LoaderIndicator />
              </div>
            ) : (
              rows.map((row) => (
                <div
                  key={row.id}
                  style={{
                    backgroundColor: "white",
                    marginTop: "2px",
                    marginLeft: "40px",
                    marginRight: "40px",
                    borderBottom: "1px solid #e0e0e0",
                    fontFamily: fontFamily,
                    fontWeight: 300,
                    fontSize: 12,
                    height: "34px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      textAlign: "left",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    {row.reportName}
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        cursor: "pointer",
                        textAlign: "left",
                        width: 50,
                        marginLeft: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => handleViewReport(row.reportName)}
                    >
                      <span
                        style={{
                          color: "#2aa7e0",
                          fontFamily: fontFamily,
                          fontWeight: 300,
                          fontSize: 14,
                        }}
                      >
                        View
                      </span>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        width: 50,
                        marginRight: "10px",
                      }}
                    >
                      <img
                        src="/image4.png"
                        onClick={async () => {
                          // Behave like PDF icon: load data if needed then download locally
                          await handleExcelReport(row.reportName);
                        }}
                        alt="Excel"
                        style={{
                          height: 30,
                          width: 30,
                          verticalAlign: "middle",
                          color: "#2aa7e0",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        width: 50,
                        marginRight: "10px",
                      }}
                    >
                      <img
                        src="/image6.png"
                        onClick={() => {
                          // Use the same function as the PDF button - loads data and generates PDF directly
                          handlePdfReport(row.reportName);
                        }}
                        alt="PDF"
                        style={{
                          height: 30,
                          width: 30,
                          marginRight: "10px",
                          verticalAlign: "middle",
                          color: "#2aa7e0",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        width: 80,
                        marginRight: "10px",
                      }}
                    >
                      <EmailIcon
                        onClick={() => {
                          setSelectedReport(row.reportName);
                          setScheduleDialogOpen(true);
                        }}
                        style={{
                          color: "#2aa7e0",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))
            )}
          </>
        ) : (
          <>
            {/* Search and Filter Section */}
            <div
              style={{
                marginLeft: "20px",
                marginRight: "20px",
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 1,
                paddingBottom: "10px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <input
                type="text"
                placeholder="Search by email or organization..."
                value={searchTerm}
                onChange={handleSearchChange}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontFamily: fontFamily,
                  fontSize: "12px",
                  flex: 1,
                }}
              />

              <Button
                onClick={filterReportData}
                style={{
                  backgroundColor: InstaColors.primary,
                  color: "white",
                  fontFamily: fontFamily,
                  textTransform: "none",
                  fontSize: "12px",
                  padding: "8px 16px",
                }}
              >
                Search
              </Button>

              <Button
                onClick={() => {
                  setSearchTerm("");
                  setFilteredReportData(reportDataForView);
                }}
                style={{
                  backgroundColor: "#f0f0f0",
                  color: "#555",
                  fontFamily: fontFamily,
                  textTransform: "none",
                  fontSize: "12px",
                  padding: "8px 16px",
                }}
              >
                Clear
              </Button>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  width: "320px",
                }}
              >
                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} size="small" sx={{ width: 200 }} />
                  )}
                />

                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} size="small" sx={{ width: 200 }} />
                  )}
                />
              </Box>

              {/* {filteredByDateData.length > 0 && ( */}
              <>
                <Button
                  onClick={() => handleDownloadExcelReport(viewingReportName, true)}
                  startIcon={<DescriptionIcon />}
                  style={{
                    backgroundColor: "#4CAF50",
                    color: "white",
                    fontFamily: fontFamily,
                    textTransform: "none",
                    fontSize: "12px",
                    padding: "8px 16px",
                  }}
                >
                  Download Excel
                </Button>
                <Button
                  onClick={() =>
                    handleDownloadPDF(
                      viewingReport
                        ? rows.find((r) => handleViewReport.name === r.reportName)?.reportName ||
                            "User Audit Report"
                        : "User Audit Report"
                    )
                  }
                  startIcon={<PictureAsPdfIcon />}
                  style={{
                    backgroundColor: "#d32f2f",
                    color: "white",
                    fontFamily: fontFamily,
                    textTransform: "none",
                    fontSize: "12px",
                    padding: "8px 16px",
                  }}
                >
                  Download PDF
                </Button>
              </>
              {/* )} */}
            </div>

            {/* Filter status information */}
            <div
              style={{
                marginTop: "10px",
                marginLeft: "20px",
                marginBottom: "10px",
                fontFamily: fontFamily,
                fontSize: "12px",
                color: "#666",
              }}
            >
              {startDate && endDate
                ? `Showing data from ${formatDate(startDate)} to ${formatDate(
                    endDate
                  )} (${filteredByDateData.length} records)`
                : `Showing all ${reportDataForView.length} records`}
            </div>
            {/* Report View Header */}
            <div
              style={{
                backgroundColor: InstaColors.primary,
                height: "34px",
                fontFamily: fontFamily,
                fontWeight: 400,
                fontSize: 13,
                paddingLeft: "20px",
                paddingRight: "20px",
                alignItems: "center",
                display: "flex",
                position: "sticky",
                top: "80px", // Adjust this value based on your search section height
                zIndex: 1,
              }}
            >
              {(viewingReportName === "User Audit Report"
                ? viewAuditColumnsData
                : viewExportedColumnsData
              ).map((column, index) => (
                <div
                  title={column.headerName}
                  key={index}
                  style={{
                    flex: 1,
                    textAlign: "left",
                    color: "white",
                    marginLeft: "5px",
                    marginRight: "5px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  {column.headerName}
                </div>
              ))}
            </div>
            {/* Report Data Rows */}
            <div
              style={{
                maxHeight: "calc(100vh - 200px)", // Adjust this value based on your layout
                overflowY: "auto",
              }}
            >
              {filteredByDateData.length > 0 ? (
                <>
                  {/* Group data by date and display with date headers */}
                  {Object.entries(groupDataByDate(filteredByDateData)).map(([date, rows]) => (
                    <React.Fragment key={date}>
                      {/* Date header */}
                      <div
                        style={{
                          backgroundColor: "#f5f5f5",
                          padding: "8px 20px",
                          fontFamily: fontFamily,
                          fontWeight: 500,
                          fontSize: 13,
                          color: "#333",
                          borderBottom: "1px solid #e0e0e0",
                        }}
                      >
                        {formatDate(date)}
                      </div>

                      {/* Rows for this date */}
                      {rows.map((row, rowIndex) => (
                        <div
                          key={rowIndex}
                          style={{
                            backgroundColor: "white",
                            borderBottom: "1px solid #e0e0e0",
                            fontFamily: fontFamily,
                            fontWeight: 300,
                            fontSize: 12,
                            height: "34px",
                            display: "flex",

                            alignItems: "center",
                            paddingLeft: "20px",
                            paddingRight: "20px",
                          }}
                        >
                          {(viewingReportName === "User Audit Report"
                            ? viewAuditColumnsData
                            : viewExportedColumnsData
                          ).map((column, colIndex) => (
                            <div
                              title={
                                column.field.includes("actionDate") && row[column.field]
                                  ? formatDate(row[column.field].toLowerCase())
                                  : row[column.field]
                              }
                              key={colIndex}
                              style={{
                                flex: 1,
                                textAlign: "left",
                                marginLeft: "5px",
                                height: "34px",
                                marginRight: "5px",
                                display: "flex",
                                alignItems: "center",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {column.field.includes("actionDate") && row[column.field]
                                ? formatDate(row[column.field])
                                : row[column.field]}
                            </div>
                          ))}
                        </div>
                      ))}
                    </React.Fragment>
                  ))}

                  {viewingReportName === "Extraction Report" && filteredByDateData.length > 0 && (
                    <div
                      style={{
                        backgroundColor: "#f9f9f9",
                        borderBottom: "1px solid #e0e0e0",
                        fontFamily: fontFamily,
                        fontWeight: 500,
                        fontSize: 12,
                        height: "34px",
                        display: "flex",
                        alignItems: "center",
                        // marginLeft: '20px',
                        // marginRight: '20px',
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                    >
                      {viewExportedColumnsData.map((column, colIndex) => {
                        const totals = calculateTotals(filteredByDateData);
                        return (
                          <div
                            key={colIndex}
                            style={{
                              flex: 1,
                              textAlign: "left",
                              marginLeft: "5px",
                              height: "34px",
                              marginRight: "5px",
                              display: "flex",
                              alignItems: "center",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {totals && totals[column.field] !== undefined
                              ? totals[column.field]
                              : ""}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "20px",
                    fontFamily: fontFamily,
                    fontSize: "14px",
                    color: "#666",
                  }}
                >
                  No data available for the selected date range
                </div>
              )}
            </div>
          </>
        )}

        {/* Email Dialog */}
        {emailDialogOpen && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              zIndex: 1000,
            }}
          >
            <h3 style={{ marginBottom: "20px", fontFamily: fontFamily }}>Send Report via Email</h3>
            <div style={{ marginBottom: "15px" }}>
              <input
                type="email"
                placeholder="Recipient Email"
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontFamily: fontFamily,
                  fontSize: "12px",
                }}
              />
            </div>
            <div style={{ marginBottom: "15px" }}>
              <input
                type="text"
                placeholder="Email Subject"
                value={emailSubject}
                onChange={(e) => setEmailSubject(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontFamily: fontFamily,
                  fontSize: "12px",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button
                onClick={() => setEmailDialogOpen(false)}
                style={{
                  backgroundColor: "#f0f0f0",
                  color: "#555",
                  fontFamily: fontFamily,
                  textTransform: "none",
                  fontSize: "12px",
                  padding: "8px 16px",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() =>
                  handleEmailPDF(
                    rows.find((r) => handleViewReport.name === r.reportName)?.reportName ||
                      "User Audit Report"
                  )
                }
                style={{
                  backgroundColor: "#1976d2",
                  color: "white",
                  fontFamily: fontFamily,
                  textTransform: "none",
                  fontSize: "12px",
                  padding: "8px 16px",
                }}
              >
                Send
              </Button>
            </div>
          </div>
        )}

        {/* Schedule Email Dialog */}
        <Dialog open={scheduleDialogOpen} onClose={() => setScheduleDialogOpen(false)}>
          <DialogTitle>Schedule Email Reports</DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                mt: 2,
                minWidth: "300px",
              }}
            >
              <FormControl fullWidth>
                <InputLabel>Report</InputLabel>
                <Select
                  value={selectedReport}
                  label="Report"
                  onChange={(e) => setSelectedReport(e.target.value)}
                >
                  {rows.map((row) => (
                    <MenuItem key={row.id} value={row.reportName}>
                      {row.reportName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Frequency</InputLabel>
                <Select
                  value={selectedFrequency}
                  label="Frequency"
                  onChange={(e) => setSelectedFrequency(e.target.value)}
                >
                  {frequencyOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                label="Email Address"
                value={selectedEmail}
                onChange={(e) => setSelectedEmail(e.target.value)}
                fullWidth
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setScheduleDialogOpen(false)}>Cancel</Button>
            <Button onClick={handleScheduleEmail} variant="contained" color="primary">
              Save Schedule
            </Button>
          </DialogActions>
        </Dialog>

        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <LoaderIndicator />
          </div>
        )}
      </div>
    </LocalizationProvider>
  );
}
